import store from '@/store'
import { authSavRoute } from '@/router/routeSavRole.js'
export default {
  data() {
    return {
      userAuth: false,
    }
  },
  methods: {
    checkUser() {
      this.userAuth = false
      this.$axios
        .get(`check-user`)
        .then((res) => {
          if (res && res.status === 200) {
            this.userAuth = true
            this.$store.dispatch('setDataVerification', true)
            if (!this.isLocal) {
              this.$store.dispatch('keepAlive', true)
            }
            this.$axios.get(`system-notifications/application/ireg`).then((res) => {
              this.$store.dispatch('systemNotification', res.data)
            })
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    // checkUserSavitarna() {
    //   this.userAuth = false
    //   // hide enc
    //   if(!this.$route.query.enc){
    //     if(!store.getters.getEnc){ this.$root.$emit('SAV_LOGIN_ERROR') }
    //     this.$route.query.enc = store.getters.getEnc
    //   } else {
    //     this.$store.dispatch('setEnc', this.$route.query.enc)
    //   }
    //   //
    //   if(!this.$route.query.xid){
    //     if(!store.getters.getXid){ this.$root.$emit('SAV_LOGIN_ERROR') }
    //     this.$route.query.xid = store.getters.getXid
    //   } else {
    //     this.$store.dispatch('setXid', this.$route.query.xid)
    //   }
    //   window.history.replaceState({}, '',  `${window.location.origin}${window.location.pathname}`);
    // //  hide enc end
    //   this.$axios
    //     .post(`ipasas`, { enc: this.$route.query.enc, lang: store.getters.getSystemLang })
    //     .then((res) => {
    //       if (res && res.status === 200) {
    //         this.$store.dispatch('savitarnaLogin', res.data).then(() => {
    //           this.$store.dispatch('setDataVerification', true)
    //           this.$store.dispatch('loadTooltips')
    //           this.$store.dispatch('loadNotifications')
    //           this.$axios.get(`system-notifications/application/self-service`).then((res) => {
    //             this.$store.dispatch('systemNotification', res.data)
    //           })
    //           if (!authSavRoute(this.$route.name)) {
    //             this.$router.push({ name: 'homepage' })
    //           }
    //           this.userAuth = true
    //         })
    //       } else {
    //         this.$root.$emit('SAV_LOGIN_ERROR')
    //       }
    //     })
    //     .catch((err) => {
    //       if(err.response.status === 408){
    //         this.$store.dispatch('setEnc', null)
    //         this.$store.dispatch('setXid', null)
    //         this.$root.$emit('SAV_LOGIN_ERROR')
    //       }
    //       if(err.response.status === 451){
    //         this.$root.$emit('DATA_ERROR', err)
    //         setTimeout(() => {
    //           window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=1`
    //         }, 6000)
    //         // this.$root.$emit('SAV_INCAPACITATED_ERROR')
    //       } else {
    //         this.$root.$emit('SAV_LOGIN_ERROR')
    //       }
    //     })
    // },
    checkUserSavitarna() {
      this.userAuth = false

      if(!this.$route.query.xid){
        if(!store.getters.getXid){ this.$root.$emit('SAV_LOGIN_ERROR') }
        this.$route.query.xid = store.getters.getXid
      } else {
        this.$store.dispatch('setXid', this.$route.query.xid)
      }

      // hide enc
      if (this.$route.query.enc) {
        let enc = this.$route.query.enc
        this.userAuth = false
        window.history.replaceState({}, '',  `${window.location.origin}${window.location.pathname}`)
        this.$axios
          .post(`ipasas`, { enc: enc, lang: store.getters.getSystemLang })
          .then((res) => {
            if (res && res.status === 200) {
              this.$store.dispatch('savitarnaLogin', res.data).then(() => {
                this.$store.dispatch('setDataVerification', true)
                this.$store.dispatch('loadTooltips')
                this.$store.dispatch('loadNotifications')
                this.$axios.get(`system-notifications/application/self-service`).then((res) => {
                  this.$store.dispatch('systemNotification', res.data)
                })
                if (!authSavRoute(this.$route.name)) {
                  this.$router.push({ name: 'homepage' })
                }
                this.userAuth = true
              })
            } else {
              this.$root.$emit('SAV_LOGIN_ERROR')
            }
          })
          .catch((err) => {
            if(err.response.status === 408){
              this.$store.dispatch('setEnc', null)
              this.$store.dispatch('setXid', null)
              this.$root.$emit('SAV_LOGIN_ERROR')
            }
            if(err.response.status === 451){
              this.$root.$emit('DATA_ERROR', err)
              setTimeout(() => {
                window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=1`
              }, 6000)
              // this.$root.$emit('SAV_INCAPACITATED_ERROR')
            } else {
              this.$root.$emit('SAV_LOGIN_ERROR')
            }
          })
      } else {
        this.userAuth = true
      }
    },
  },
}
